import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { JOSEError, JWKSTimeout } from '../util/errors.js';

var fetchJwks = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, timeout, options) {
    var controller, id, timedOut, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timedOut = false;

            if (typeof AbortController === 'function') {
              controller = new AbortController();
              id = setTimeout(function () {
                timedOut = true;
                controller.abort();
              }, timeout);
            }

            _context.next = 4;
            return fetch(url.href, {
              signal: controller ? controller.signal : undefined,
              redirect: 'manual',
              headers: options.headers
            }).catch(function (err) {
              if (timedOut) throw new JWKSTimeout();
              throw err;
            });

          case 4:
            response = _context.sent;
            if (id !== undefined) clearTimeout(id);

            if (!(response.status !== 200)) {
              _context.next = 8;
              break;
            }

            throw new JOSEError('Expected 200 OK from the JSON Web Key Set HTTP response');

          case 8:
            _context.prev = 8;
            _context.next = 11;
            return response.json();

          case 11:
            return _context.abrupt("return", _context.sent);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](8);
            throw new JOSEError('Failed to parse the JSON Web Key Set HTTP response as JSON');

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 14]]);
  }));

  return function fetchJwks(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export default fetchJwks;